<template lang="pug">
  #confirm-change-plan.mt-3
    loading(v-if="isLoading === true", :height="200")
    b-card(v-else)
      app-messages-with-icon(:errorMessages="orderErrors")
      h4.mx-2.mt-1.mb-4.text-center.border.message-border-style.border-primary.rounded.p-3 申し込み内容をご確認ください。
      b-container
        //- 変更後のプラン
        .mb-3
          h5.plan-bg(:class="title_class") プラン変更内容
          b-form-text.border-color-plan(:class="data_class")
            b-row
              b-col(cols='1')
              b-col(cols='4')
                h4.for-weight-bold.text-center 現在のプラン
                .mb-1(v-for="plan_name in planChangeInfo.before_plan")
                  b-card(v-if="plan_name === 'appsuite'", header="AppSuite", class='text-center font-weight-bold')
                    b-card-text
                      small ご利用いただけるサービス
                      .mb-2
                      div.mb-3.mr-3
                        img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                      small ご契約中のユーザー数
                      h5.font-weight-bold {{ planChangeInfo.user_list[plan_name] }}ユーザー
                  b-card(v-else, :header="getPlanInfo(plan_name).title", class='text-center font-weight-bold')
                    b-card-text
                      small ご利用いただけるサービス
                      .mb-2
                      div.mb-3.mr-3(v-if="getPlanInfo(plan_name).services.includes('neo')")
                        img.logo_desknets(src='@/assets/images/logo_desknetsneo_clear_background.png')
                      div.mb-3.mr-3(v-if="getPlanInfo(plan_name).services.includes('appsuite')")
                        img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                      div.mb-3.mr-3(v-if="getPlanInfo(plan_name).services.includes('chatluck')")
                        img.logo_chatluck(src='@/assets/images/logo_chatluck.png')
                      small ご契約中のユーザー数
                      h5.font-weight-bold {{ planChangeInfo.user_list[plan_name] }}ユーザー
              b-col(cols='2', class='d-flex align-items-center justify-content-center')
                b-icon(icon="arrow-right" variant="secondary" font-scale="4")
              b-col(cols='4')
                h4.for-weight-bold.text-center 変更後のプラン
                b-card.mb-1(:header="after_plan_info.title", class='text-center font-weight-bold')
                  b-card-text
                    small ご利用いただけるサービス
                    .mb-2
                    div.mb-3.mr-3(v-if="after_plan_info.services.includes('neo')")
                      img.logo_desknets(src='@/assets/images/logo_desknetsneo_clear_background.png')
                    div.mb-3.mr-3(v-if="after_plan_info.services.includes('appsuite')")
                      img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                    div.mb-3.mr-3(v-if="after_plan_info.services.includes('chatluck')")
                      img.logo_chatluck(src='@/assets/images/logo_chatluck.png')
                    small 変更後のユーザー数
                    h5.font-weight-bold {{ planChangeInfo.plan_user }}ユーザー
                b-card.mb-1(v-if="no_change_to_appsuite", header="AppSuite", class='text-center font-weight-bold')
                  b-card-text
                    small ご利用いただけるサービス
                    .mb-2
                    div.mb-3.mr-3
                      img.logo_appsuite(src='@/assets/images/logo_appsuite.png')
                    small 変更後のユーザー数
                    h5.font-weight-bold {{ contract_appsuite_user }}ユーザー
                b-card.mb-1(v-if="no_change_to_chatluck", :header="plans.chatluck.title", class='text-center font-weight-bold')
                  b-card-text
                    small ご利用いただけるサービス
                    .mb-2
                    div.mb-3.mr-3
                      img.logo_chatluck(src='@/assets/images/logo_chatluck.png')
                    small 変更後のユーザー数
                    h5.font-weight-bold {{ contract_chat_user }}ユーザー
              b-col(cols='1')
        //- 変更後のユーザー数
        .mb-3
          h5.plan-bg(:class="title_class") 変更後のユーザー数
          b-form-text.border-color-plan(:class="data_class") {{ planChangeInfo['plan_user'] }}ユーザー
        //- desknet's NEO ドメイン名
        .mb-3(v-if="isDisplayNeoDomain")
          h5.neo-bg(:class="title_class") desknet's NEO ご希望サブドメイン名
          b-form-text.border-primary(:class="data_class") {{ planChangeInfo['neo_sub_domain'] }}.dn-cloud.com
        //- desknet's NEO 無料お試し版からのデータ移行
        .mb-3(v-if="isDisplayNeoDomain")
          h5.neo-bg(:class="title_class") desknet's NEO 無料お試し版からのデータ移行
          b-form-text.border-primary(:class="data_class")
            p.mb-0 {{ planChangeInfo['migration'] === true ? '希望する' : '希望しない' }}
            p.mb-0(v-if="planChangeInfo['migration'] === true") 試使用環境URL：{{ planChangeInfo['migration_url'] }}
        //- ChatLuck ドメイン名
        .mb-3(v-if="isDisplayChatDomain")
          h5.chat-bg(:class="title_class") ChatLuck ご希望サブドメイン名
          b-form-text.border-success(:class="data_class") {{ planChangeInfo['chat_sub_domain'] }}.chatluck.net
        //- ChatLuck 無料お試し版からのデータ移行
        .mb-3(v-if="isDisplayChatDomain")
          h5.chat-bg(:class="title_class") ChatLuck 無料お試し版からのデータ移行
          b-form-text.border-success(:class="data_class")
            p.mb-0 {{ planChangeInfo['chat_migration'] === true ? '希望する' : '希望しない' }}
            p.mb-0(v-if="planChangeInfo['chat_migration'] === true") 試使用環境URL：{{ planChangeInfo['chat_migration_url'] }}
        //- 変更希望日
        .mb-3(v-if="planChangeInfo['migration'] === false && planChangeInfo['chat_migration'] === false")
          h5.other-bg(:class="title_class") 変更希望日
          b-form-text.border-color-other(:class="data_class") {{ this.showDateString(planChangeInfo['preferred_date']) }}
        //- 無料お試し版からのデータ移行作業日時
        .mb-3(v-else)
          h5.other-bg(:class="title_class") 無料お試し版からのデータ移行作業日時
          b-form-text.border-color-other(:class="data_class") 作業日時：{{ display_migration_date }}
        //- お見積番号
        .mb-3
          h5.other-bg(:class="title_class") お見積番号
          b-form-text.border-color-other(:class="data_class")
            template(v-if="planChangeInfo['estimate_no'] !== null && planChangeInfo['estimate_no'] !== ''")
              p.mb-0 No ：
              p.mb-0.line-break {{ planChangeInfo['estimate_no'] }}
        //- 備考
        .mb-3
          h5.other-bg(:class="title_class") 備考
          b-form-text.border-color-other.line-break(:class="data_class") {{ planChangeInfo['order_remarks'] }}

        contract-conditions.mx-3.mb-4(
          :show-neo="['standard', 'premium', 'chatplus'].includes(planChangeInfo.after_plan)",
          :show-chat="['premium', 'chatplus'].includes(planChangeInfo.after_plan) || planChangeInfo.before_plan.includes('chat')",
          :show-individual-terms="false")

        //- 見積書
        .mb-3(v-if="has_special_priced_item === false")
          h5.other-bg(:class="title_class") 見積書を作成する
          b-form-text.border-color-other(:class="data_class")
            app-messages-with-icon(:errorMessages="quotationErrors")
            b-container.my-2
              b-row
                b-col(cols="8")
                b-col(cols="3")
                  b-button.float-right.mr-5(pill, variant="outline-success", size="lg", :disabled="isApiLoading === true", @click="createQuotation")
                    .float-left.search_message.mr-1.font-weight-bold 見積書作成
                    b-icon.float-right.next-icon(icon="arrow-right-circle")

        //- 申し込む
        .mb-3
          h5.other-bg(:class="title_class") 変更を申し込む
          b-form-text.border-color-other(:class="data_class")
            b-container.my-2
              b-row
                b-col(cols="1")
                b-col(cols="7")
                  b-button(pill, variant="outline-secondary", size="lg", :disabled="isApiLoading === true", @click="fixApply")
                    .float-right.search_message.ml-1.font-weight-bold 申し込み内容を修正する
                    b-icon.float-right.next-icon(icon="arrow-left-circle")
                b-col(cols="3")
                  b-button.order-confirm-button.float-right.mr-5(pill, variant="outline-success", size="lg", :disabled="isApiLoading === true", @click="applyPlanChange")
                    span.search_message.mr-1.font-weight-bold 申し込みを確定する
                    b-icon.next-icon(icon="arrow-right-circle")
</template>

<script>
// コンポーネント
import Loading from '@/components/Loading'
import AppMessagesWithIcon from '@/components/AppMessagesWithIcon';
import ContractConditions from "@/components/ContractConditions";

// API
import Api from '@/repositories/api'
const S213ContractChanges = Api.get('s213ContractChanges')
const S214Quotation = Api.get('s214Quotation');

export default {
  name: 'ConfirmChangePlan',
  props: {
    has_special_priced_item: { type: Boolean, required: true }, // 優待価格商品保有フラグ
    plan_change_data       : { type: Object, required: true },  // プラン変更データ
  },
  components: {
    Loading,
    AppMessagesWithIcon,
    ContractConditions,
  },
  data() {
    return {
      // スタイル用クラス
      title_class: 'ml-3 py-2 border-top border-bottom font-weight-bold',
      data_class : 'ml-3 py-2 px-2 mb-2 border-top border-bottom display-font-size',

      // プラン情報
      plans: {
        'light'   : { title: 'ライト', price: 660, services:['neo'], plan: 'light' },
        'standard': { title: 'スタンダード', price: 880, services:['neo', 'appsuite'], plan: 'standard' },
        'premium' : { title: 'プレミアム', price: 1100, services:['neo', 'appsuite', 'chatluck'], plan: 'premium' },
        'chatplus': { title: 'チャットプラス', price: 836, services:['neo', 'chatluck'], plan: 'chatplus' },
        'chatluck': { title: 'ChatLuck', price: 330, services:['chatluck'], plan: 'chatluck' },
      },

      // ローディングフラグ
      isLoading   : false, // 画面
      isApiLoading: false, // API

      // エラーメッセージ
      orderErrors    : [], // 申込エラー
      quotationErrors: [], // 見積書作成エラー

      // 見積枝番（セッションから取得）
      estimateBranch: sessionStorage.getItem('estimate_branch'),

      // プラン変更内容
      planChangeInfo: {
        contract_no        : null,  // 契約番号
        before_plan        : [],    // 変更前プラン
        user_list          : {},    // 変更前のユーザー数
        after_plan         : '',    // 変更後プラン
        plan_user          : 0,     // 変更後のユーザー数
        neo_sub_domain     : '',    // desknet's NEO ドメイン名
        migration          : false, // 試使用からの移行フラグ（NEO）
        migration_url      : '',    // 試使用環境URL
        chat_sub_domain    : '',    // ChatLuck ドメイン名
        chat_migration     : false, // 試使用からの移行フラグ（Chat）
        chat_migration_url : '',    // ChatLuck試使用環境URL
        preferred_date     : '',    // 変更希望日
        migration_date     : '',    // 試使用からの移行作業日時
        migration_time_from: '',    // 試使用からの移行作業時刻（から）
        migration_time_to  : '',    // 試使用からの移行作業時刻（まで）
        estimate_no        : '',    // お見積番号
        order_remarks      : '',    // 備考
      }
    }
  },
  /**
   * 初期処理
   */
  created () {
    // 初期処理
    this.initialize()
  },
  computed: {
    /**
     * 変更後のプラン情報を取得
     */
    after_plan_info() {
      return this.getPlanInfo(this.planChangeInfo['after_plan'])
    },
    /**
     * desknet's NEO ドメイン名 を表示するかどうか
     */
    isDisplayNeoDomain() {
      // プラン変更内容.変更前プランにChatLuckが含まれる場合
      return this.planChangeInfo['before_plan'].includes('chat') &&
        // desknet's NEOが変更前プランに含まれない
        this.planChangeInfo['before_plan'].includes('neo') === false &&
        // ライトプランが変更前プランに含まれない
        this.planChangeInfo['before_plan'].includes('light') === false &&
        // スタンダードプランが変更前プランに含まれない
        this.planChangeInfo['before_plan'].includes('standard') === false &&
        // プラン変更内容.変更後プラン = プレミアム または チャットプラス の場合
        ['premium', 'chatplus'].includes(this.planChangeInfo['after_plan'])
    },
    /**
     * ChatLuck ドメイン名 を表示するかどうか
     */
    isDisplayChatDomain() {
      return this.planChangeInfo['before_plan'].includes('chat') === false &&
      (
        (
          // プラン変更内容.変更前プラン = desknet's NEO または ライト の場合
          (
            this.planChangeInfo['before_plan'].includes('neo') ||
            this.planChangeInfo['before_plan'].includes('light')
          ) &&
          // プラン変更内容.変更後プラン = プレミアム または チャットプラス の場合
          ['premium', 'chatplus'].includes(this.planChangeInfo['after_plan'])
        ) ||
        (
          // プラン変更内容.変更前プラン = スタンダード の場合
          this.planChangeInfo['before_plan'].includes('standard') &&
          // プラン変更内容.変更後プラン = プレミアム の場合
          this.planChangeInfo['after_plan'] === 'premium'
        )
      )
    },
    /**
     * AppSuiteに変更がないかどうか
     */
    no_change_to_appsuite() {
      // 現在のプランに存在する かつ 変更後のプランがチャットプラスの場合
      if (this.planChangeInfo.before_plan.includes('appsuite') && this.planChangeInfo.after_plan === 'chatplus') {
        // 変更なし
        return true
      }

      // 変更あり
      return false
    },
    /**
     * AppSuiteの契約ユーザー数
     */
    contract_appsuite_user() {
      // AppSuiteが存在する場合
      if ('appsuite' in this.planChangeInfo.user_list) {
        // AppSuiteの契約中ユーザー数を返す
        return this.planChangeInfo.user_list.appsuite
      }

      // 見つからなかった場合は空文字を返す
      return ''
    },
    /**
     * ChatLuckに変更がないかどうか
     */
    no_change_to_chatluck() {
      // 現在のプランに存在する かつ 変更後のプランがスタンダードの場合
      if (this.planChangeInfo.before_plan.includes('chat') && this.planChangeInfo.after_plan === 'standard') {
        // 変更なし
        return true
      }

      // 変更あり
      return false
    },
    /**
     * ChatLuckの契約ユーザー数
     */
    contract_chat_user() {
      // ChatLuckが存在する場合
      if ('chat' in this.planChangeInfo.user_list) {
        // ChatLuckの契約中ユーザー数を返す
        return this.planChangeInfo.user_list.chat
      }

      // 見つからなかった場合は空文字を返す
      return ''
    },
    /**
     * 無料お試し版からのデータ移行作業日時のフォーマットを修正した文字列を返す
     */
    display_migration_date() {
      // 2021年12月2日(木) 11:00 - 12:00 のような形式にする
      return this.showDateString(this.planChangeInfo.migration_date, this.planChangeInfo.migration_time_from, this.planChangeInfo.migration_time_to)
    },
  },
  methods: {
    /**
     * 初期処理
     */
    async initialize() {
      // ローディングを開始する
      this.isLoading = true

      // 販売種別利用制限チェックを行う
      await this.validateSalesChannel()

      // セッションストレージ.見積枝番 が空ではない場合
      if (this.estimateBranch !== null && this.estimateBranch !== '') {
        // 「S21407_プラン変更内容取得処理」を実行する
        await S214Quotation.planChangeDetail({
          // リクエストパラメータ
          estimate_branch: this.estimateBranch, // 見積枝番
        })
          // 処理に成功した場合
          .then((response) => {
            // S21407_プラン変更内容取得処理.レスポンスの各項目を、「S10302_プラン選択」画面で入力された情報にセットする
            this.plan_change_data.contract_no         = response.data.contract_no                                         // 契約番号
            this.plan_change_data.before_plan         = response.data.current_plan.map(item => item.replace('_user', '')) // 変更前プラン
            this.plan_change_data.user_list           = response.data.current_user                                        // 変更前ユーザー数
            this.plan_change_data.after_plan          = response.data.changed_plan.replace('_user', '')                   // 変更後プラン
            this.plan_change_data.plan_user           = response.data.changed_user                                        // 変更後のユーザー数
            this.plan_change_data.neo_sub_domain      = response.data.neo_domain                                          // desknet's NEO ドメイン名
            this.plan_change_data.migration           = response.data.migration === '1' ? true : false                    // 試使用からの移行フラグ（NEO）
            this.plan_change_data.migration_url       = response.data.migration_url                                       // 試使用環境URL
            this.plan_change_data.chat_sub_domain     = response.data.chat_domain                                         // ChatLuck ドメイン名
            this.plan_change_data.chat_migration      = response.data.chat_migration === '1' ? true : false               // 試使用からの移行フラグ（Chat）
            this.plan_change_data.chat_migration_url  = response.data.chat_migration_url                                  // ChatLuck試使用環境URL
            this.plan_change_data.preferred_date      = response.data.opening_date                                        // 変更希望日
            this.plan_change_data.migration_date      = response.data.migration_date                                      // 試使用からの移行作業日時
            this.plan_change_data.migration_time_from = response.data.migration_time_from                                 // 試使用からの移行作業時刻（から）
            this.plan_change_data.migration_time_to   = response.data.migration_time_to                                   // 試使用からの移行作業時刻（まで）
            this.plan_change_data.estimate_no         = response.data.estimate_no                                         // お見積番号
            this.plan_change_data.order_remarks       = response.data.order_remarks                                       // 備考
          })
          // 処理に失敗した場合
          .catch((error) => {
            // 共通エラー処理
            this.apiError(error, 'プラン変更内容取得処理', 'Service')
            // エラーメッセージを表示する
            this.setErrors(error)
            this.orderErrors = this.errors
          })
      }

      // 「S10302_プラン選択」画面で入力された情報をプラン変更内容にセットする
      for (let key of Object.keys(this.planChangeInfo)) {
        this.planChangeInfo[key] = this.plan_change_data[key]
      }

      // ローディングを終了する
      this.isLoading = false
    },
    /**
     * プラン情報を取得する
     *
     * @param  {string} sPlanName プラン名
     * @return {object}           プラン情報
     */
    getPlanInfo(sPlanName) {
      // プランが存在する場合
      if (sPlanName in this.plans) {
        // 指定されたプランを返す
        return this.plans[sPlanName]
      }

      // desknet's NEOの場合
      if (sPlanName === 'neo') {
        // ライトプランを返す
        return this.plans['light']
      }

      // ChatLuckの場合
      if (sPlanName === 'chat') {
        // ChatLuckを返す
        return this.plans['chatluck']
      }

      // プランが存在しない場合は初期データを返す
      return {
        title   : '',
        price   : '',
        services: [],
        plan    : '',
      }
    },
    /**
     * 見積書を作成する
     *
     * @return {void}
     */
    createQuotation() {
      // APIローディングを開始する
      this.isApiLoading = true

      // エラーメッセージを初期化する
      this.orderErrors     = []
      this.quotationErrors = []

      // リクエストパラメータを作成する
      let params = this.createParams()

      // S21406_プラン変更見積書作成処理を実行する
      S214Quotation.createPlanChange(params)
        // 処理に成功した場合
        .then(() => {
          // 「S11700_見積書一覧」画面へ遷移する
          this.$router.push({
            name: 'QuotationList',
          })
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, 'プラン変更見積書作成処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          this.quotationErrors = this.errors

          // APIローディングを終了する
          this.isApiLoading = false
        })
    },
    /**
     * プラン変更を申し込む
     */
    applyPlanChange() {
      // APIローディングを開始する
      this.isApiLoading = true

      // エラーメッセージを初期化する
      this.orderErrors     = []
      this.quotationErrors = []

      // リクエストパラメータを作成する
      let params = this.createParams()

      // セッションストレージ.見積枝番 が空ではない場合
      if (this.estimateBranch !== null && this.estimateBranch !== '') {
        // リクエストパラメータに見積枝番を追加する
        params['estimate_branch'] = this.estimateBranch
      }

      // S21305_プラン変更処理を実行する
      S213ContractChanges.addPlan(params)
        // 処理に成功した場合
        .then(() => {
          // 「S11000_お申し込み履歴」画面へ遷移する
          this.$router.push({
            name: 'OrderHistory'
          })
        })
        // 処理に失敗した場合
        .catch((error) => {
          // 共通エラー処理
          this.apiError(error, 'プラン変更処理', 'Service')
          // エラーメッセージを表示する
          this.setErrors(error)
          this.orderErrors = this.errors
          // 画面一番上へスクロールをする
          this.pageTopScroll()

          // ローディングを終了する
          this.isApiLoading = false
        })
    },
    /**
     * リクエストパラメータを作成する
     */
    createParams() {
      // リクエストパラメータを作成する
      let params = {
        contract_no    : Number(this.planChangeInfo.contract_no),                 // 契約番号
        changed_plan   : this.planChangeInfo.after_plan + '_user',                // 変更後のプラン
        changed_user   : this.planChangeInfo.plan_user,                           // 変更後のユーザー数
        neo_domain     : this.planChangeInfo.neo_sub_domain,                      // desknet's NEO ドメイン名
        migration      : this.planChangeInfo.migration === true ? '1' : '0',      // 試使用からの移行フラグ（NEO）
        chat_domain    : this.planChangeInfo.chat_sub_domain,                     // ChatLuck ドメイン名
        chat_migration : this.planChangeInfo.chat_migration === true ? '1' : '0', // 試使用からの移行フラグ（Chat）
        estimate_no    : this.planChangeInfo.estimate_no,                         // 見積番号
        order_remarks  : this.planChangeInfo.order_remarks,                       // 備考
        provision_check: '1',                                                     // サービス利用約款など
      }

      // 試使用からの移行（NEO）がある場合
      if (this.planChangeInfo['migration'] === true) {
        // 試使用環境URLを追加する
        params['migration_url'] = this.planChangeInfo['migration_url']
        // 試使用からの移行作業日時を追加する
        params['migration_date'] = this.planChangeInfo['migration_date']
        params['migration_time_from'] = this.planChangeInfo['migration_time_from']
        params['migration_time_to'] = this.planChangeInfo['migration_time_to']
      }
      // 試使用からの移行（Chat）がある場合
      else if (this.planChangeInfo['chat_migration'] === true) {
        // 試使用環境URLを追加する
        params['chat_migration_url'] = this.planChangeInfo['chat_migration_url']
        // 試使用からの移行作業日時を追加する
        params['migration_date'] = this.planChangeInfo['migration_date']
        params['migration_time_from'] = this.planChangeInfo['migration_time_from']
        params['migration_time_to'] = this.planChangeInfo['migration_time_to']
      }
      // 上記以外の場合
      else {
        // 変更希望日を追加する
        params['opening_date'] = this.planChangeInfo['preferred_date']
      }

      return params
    },
    /**
     * 申し込み内容を修正する
     */
    fixApply() {
      // 「S10302_プラン選択」画面へ遷移する
      this.$router.push({
        name: 'ApplyPlan',
        params: {
          fixApply: true // 申し込み内容修正フラグ
        }
      })
    }
  }
}
</script>

<style scoped>
.logo_desknets {
  width:100px;
  height: auto;
}
.logo_chatluck {
  width:100px;
  height: auto;
}
.logo_appsuite {
  width:100px;
  height: auto;
}
.plan-bg {
  background-color: #fceaee;
}
.neo-bg {
  background-color: #f2ffff;
}
.chat-bg {
  background-color: #f0ffe0;
}
.other-bg {
  background-color: #f5f5f5;
}
.border-color-plan {
  border-color: #eb6ea0!important;
}
.border-color-other {
  border-color: grey!important;
}
.display-font-size {
  font-size: 16px;
}
.line-break {
  white-space: pre-wrap;
}
</style>
